import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useController } from 'react-hook-form';
import { ProviderModels } from '@modules/ai/common/forms/common/provider-models';
import { getAvailableModelConfigurations, getAvailableModelDefinitions, getUnavailableModelConfigurations } from '@modules/ai/common/model-definitions';
import { Required } from '@common/form/important-asterisk';
import { AzureModelConfigurationDialog } from './azure-model-configuration-dialog';
export function AzureAiProviderModels(props) {
    var _a, _b, _c, _d;
    const { form, className, availableProvider } = props;
    const modelConfigurations = getAvailableModelConfigurations((_b = (_a = availableProvider === null || availableProvider === void 0 ? void 0 : availableProvider.models) === null || _a === void 0 ? void 0 : _a.AZURE) !== null && _b !== void 0 ? _b : []);
    const unsupportedModelConfigurations = getUnavailableModelConfigurations((_d = (_c = availableProvider === null || availableProvider === void 0 ? void 0 : availableProvider.models) === null || _c === void 0 ? void 0 : _c.AZURE) !== null && _d !== void 0 ? _d : []);
    const modelsController = useController({ name: 'provider.openai.models', control: form.control });
    const createNewModel = useCallback((type) => {
        var _a;
        const model = getAvailableModelDefinitions((_a = availableProvider === null || availableProvider === void 0 ? void 0 : availableProvider.models) === null || _a === void 0 ? void 0 : _a.OPENAI)
            .map(md => md.model)
            .find(model => model.id === type);
        if (!model) {
            throw new Error(`Illegal Application state, Model with id ${type} not found`);
        }
        return model;
    }, [availableProvider]);
    return (_jsx(ProviderModels, { createNewModel: createNewModel, columns: columns, modelConfigurations: modelConfigurations, unsupportedModelConfigurations: unsupportedModelConfigurations, modelDialogComponent: AzureModelConfigurationDialog, modelsController: modelsController, className: className, withHeader: true }));
}
const columns = [
    {
        id: 'id',
        title: 'ID'
    },
    {
        id: 'modelName',
        title: 'Model name'
    },
    {
        id: 'deploymentName',
        title: Required('Deployment name')
    }
];
